import { CaretRight } from "@phosphor-icons/react";
import { useState } from "react";

import { SubscriptionPaymentMethodModal } from "features/payment-methods/components";

import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function AddPayment() {
  const isDesktop = useTwBreakpoint("lg");
  const { subscription } = useSelectedWorkspaceContext();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <RestrictedComponent visibleForPermissions={["billing_full"]}>
      <Button
        onClick={() => setIsOpen(true)}
        size="sm"
        rightIcon={isDesktop && <CaretRight />}
        intent={isDesktop ? "default" : "iconOnly"}
      >
        {isDesktop ? "Add payment method" : <CaretRight />}
      </Button>

      <SubscriptionPaymentMethodModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        subscriptionId={subscription.id}
      />
    </RestrictedComponent>
  );
}
